define("settings/components/modal/leave-later", ["exports", "@ember/component", "@ember/object", "@ember/object/computed", "@ember/runloop", "@ember/service", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "shared/utils/redirect", "@ember/template-factory"], function (_exports, _component, _object, _computed, _runloop, _service, _utils, _component2, _tracking, _redirect, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _dec2, _dec3, _dec4, _dec5, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _trackAccountDeletion;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/object/computed",0,"@ember/runloop",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"shared/utils/redirect",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal @close={{@canClose}} as |modal|>
    <modal.card class="has--footer">
      <modal.card-header
        @title={{t "account.profile.leave.title"}}
        class="u--p__b"
        {{did-insert this.addEventListeners}}
      />
      <modal.card-body>
        <p>{{t "account.profile.leave.sub_title"}}</p>
        <form class="o--formWrapper" id="accountDeleteFeedback">
          <input name="Name" type="hidden" value="{{this.ownerName}} ({{this.companyName}})" />
          <input class="dd-privacy-mask-user-input" name="Email" type="hidden" value={{this.ownerEmail}} />
          <div class="o--form__radio u--m__b">
            <label class="u--text--bold u--p__l__lg">
              <input name="Reason" type="radio" value="doesn't post automatically" />
              {{t "account.profile.leave.reason_automatically"}}
            </label>
          </div>
          <div class="o--form__radio u--m__b">
            <label class="u--text--bold u--p__l__lg">
              <input name="Reason" type="radio" value="confusing/difficult to use" />
              {{t "account.profile.leave.reason_confusing"}}
            </label>
          </div>
          <div class="o--form__radio u--m__b">
            <label class="u--text--bold u--p__l__lg">
              <input name="Reason" type="radio" value="switching to another platform" />
              {{t "account.profile.leave.reason_platform"}}
            </label>
          </div>
          <div class="o--form__radio u--m__b__lg qa--settings_leave_delete_reason_radio_button_other">
            <label class="u--text--bold u--p__l__lg">
              <input name="Reason" type="radio" value="other" />
              {{t "shared_words.other"}}
            </label>
          </div>
          <div class="o--formWrapper">
            <textarea
              class="qa--settings_leave_delete_reason_textarea"
              name="Message"
              placeholder={{t "account.profile.leave.feedback"}}
              rows="4"
            ></textarea>
          </div>
        </form>
        <p>{{html-safe (t "account.profile.leave.note")}}</p>
        <p>{{html-safe (t "account.profile.leave.data")}}</p>
        <p class={{if this.isHighlighted "u--text--danger"}}>
          {{t "account.profile.leave.type_destroy_part_1"}}
          <span translate="no">
            {{t "account.profile.leave.type_destroy_word"}}
          </span>
          {{t "account.profile.leave.type_destroy_part_2"}}
        </p>
        <form class="o--formWrapper" id="accountDeleteConfirmation" onsubmit="return false" {{did-insert this.onInsert}}>
          <Input @value={{this.inputValue}} class="qa--settings_leave_destroy_reason_input" />
        </form>
      </modal.card-body>
      <modal.card-footer>
        <div class="o--btnBar">
          <div
            class="o--btn o--btn--outline qa--delete_confirm u--float--right {{if this.canDestroy '' 'u--mute'}}"
            id="deleteConfirmation"
            {{on "click" this.deleteConfirmation}}
          >
            {{t "account.profile.leave.confirm_delete"}}
          </div>
          {{#if this.currentAccount.hasActiveSubscription}}
            <Shared::Ui::Button
              @onClick={{@goToFree}}
              @size="regular"
              @text={{t "account.profile.leave.go_back_to_free"}}
              @variant="primary"
              class="u--float--right"
            />
          {{/if}}
        </div>
      </modal.card-footer>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "kKq36Iyr",
    "block": "[[[8,[39,0],null,[[\"@close\"],[[30,1]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,2,[\"card\"]],[[24,0,\"has--footer\"]],null,[[\"default\"],[[[[1,\"\\n    \"],[8,[30,2,[\"card-header\"]],[[24,0,\"u--p__b\"],[4,[38,2],[[30,0,[\"addEventListeners\"]]],null]],[[\"@title\"],[[28,[37,1],[\"account.profile.leave.title\"],null]]],null],[1,\"\\n    \"],[8,[30,2,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,2],[12],[1,[28,[35,1],[\"account.profile.leave.sub_title\"],null]],[13],[1,\"\\n      \"],[10,\"form\"],[14,0,\"o--formWrapper\"],[14,1,\"accountDeleteFeedback\"],[12],[1,\"\\n        \"],[10,\"input\"],[14,3,\"Name\"],[15,2,[29,[[30,0,[\"ownerName\"]],\" (\",[30,0,[\"companyName\"]],\")\"]]],[14,4,\"hidden\"],[12],[13],[1,\"\\n        \"],[10,\"input\"],[14,0,\"dd-privacy-mask-user-input\"],[14,3,\"Email\"],[15,2,[30,0,[\"ownerEmail\"]]],[14,4,\"hidden\"],[12],[13],[1,\"\\n        \"],[10,0],[14,0,\"o--form__radio u--m__b\"],[12],[1,\"\\n          \"],[10,\"label\"],[14,0,\"u--text--bold u--p__l__lg\"],[12],[1,\"\\n            \"],[10,\"input\"],[14,3,\"Reason\"],[14,2,\"doesn't post automatically\"],[14,4,\"radio\"],[12],[13],[1,\"\\n            \"],[1,[28,[35,1],[\"account.profile.leave.reason_automatically\"],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"o--form__radio u--m__b\"],[12],[1,\"\\n          \"],[10,\"label\"],[14,0,\"u--text--bold u--p__l__lg\"],[12],[1,\"\\n            \"],[10,\"input\"],[14,3,\"Reason\"],[14,2,\"confusing/difficult to use\"],[14,4,\"radio\"],[12],[13],[1,\"\\n            \"],[1,[28,[35,1],[\"account.profile.leave.reason_confusing\"],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"o--form__radio u--m__b\"],[12],[1,\"\\n          \"],[10,\"label\"],[14,0,\"u--text--bold u--p__l__lg\"],[12],[1,\"\\n            \"],[10,\"input\"],[14,3,\"Reason\"],[14,2,\"switching to another platform\"],[14,4,\"radio\"],[12],[13],[1,\"\\n            \"],[1,[28,[35,1],[\"account.profile.leave.reason_platform\"],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"o--form__radio u--m__b__lg qa--settings_leave_delete_reason_radio_button_other\"],[12],[1,\"\\n          \"],[10,\"label\"],[14,0,\"u--text--bold u--p__l__lg\"],[12],[1,\"\\n            \"],[10,\"input\"],[14,3,\"Reason\"],[14,2,\"other\"],[14,4,\"radio\"],[12],[13],[1,\"\\n            \"],[1,[28,[35,1],[\"shared_words.other\"],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"o--formWrapper\"],[12],[1,\"\\n          \"],[10,\"textarea\"],[14,0,\"qa--settings_leave_delete_reason_textarea\"],[14,3,\"Message\"],[15,\"placeholder\",[28,[37,1],[\"account.profile.leave.feedback\"],null]],[14,\"rows\",\"4\"],[12],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,2],[12],[1,[28,[35,3],[[28,[37,1],[\"account.profile.leave.note\"],null]],null]],[13],[1,\"\\n      \"],[10,2],[12],[1,[28,[35,3],[[28,[37,1],[\"account.profile.leave.data\"],null]],null]],[13],[1,\"\\n      \"],[10,2],[15,0,[52,[30,0,[\"isHighlighted\"]],\"u--text--danger\"]],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"account.profile.leave.type_destroy_part_1\"],null]],[1,\"\\n        \"],[10,1],[14,\"translate\",\"no\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"account.profile.leave.type_destroy_word\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[1,[28,[35,1],[\"account.profile.leave.type_destroy_part_2\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[11,\"form\"],[24,0,\"o--formWrapper\"],[24,1,\"accountDeleteConfirmation\"],[24,\"onsubmit\",\"return false\"],[4,[38,2],[[30,0,[\"onInsert\"]]],null],[12],[1,\"\\n        \"],[8,[39,5],[[24,0,\"qa--settings_leave_destroy_reason_input\"]],[[\"@value\"],[[30,0,[\"inputValue\"]]]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,2,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"o--btnBar\"],[12],[1,\"\\n        \"],[11,0],[16,0,[29,[\"o--btn o--btn--outline qa--delete_confirm u--float--right \",[52,[30,0,[\"canDestroy\"]],\"\",\"u--mute\"]]]],[24,1,\"deleteConfirmation\"],[4,[38,6],[\"click\",[30,0,[\"deleteConfirmation\"]]],null],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"account.profile.leave.confirm_delete\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"],[41,[30,0,[\"currentAccount\",\"hasActiveSubscription\"]],[[[1,\"          \"],[8,[39,7],[[24,0,\"u--float--right\"]],[[\"@onClick\",\"@size\",\"@text\",\"@variant\"],[[30,3],\"regular\",[28,[37,1],[\"account.profile.leave.go_back_to_free\"],null],\"primary\"]],null],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[2]]]]]],[\"@canClose\",\"modal\",\"@goToFree\"],false,[\"shared/modal\",\"t\",\"did-insert\",\"html-safe\",\"if\",\"input\",\"on\",\"shared/ui/button\"]]",
    "moduleName": "settings/components/modal/leave-later.hbs",
    "isStrictMode": false
  });
  let LeaveLaterComponent = _exports.default = (_dec = (0, _computed.alias)('auth.currentAccount'), _dec2 = (0, _computed.readOnly)('auth.currentUserModel'), _dec3 = (0, _computed.readOnly)('currentAccount.socialProfiles.firstObject'), _dec4 = (0, _computed.readOnly)('currentUser.email'), _dec5 = (0, _computed.readOnly)('currentUser.name'), (_class = (_trackAccountDeletion = /*#__PURE__*/new WeakSet(), class LeaveLaterComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _classPrivateMethodInitSpec(this, _trackAccountDeletion);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "errors", _descriptor3, this);
      _initializerDefineProperty(this, "intl", _descriptor4, this);
      _initializerDefineProperty(this, "segment", _descriptor5, this);
      _initializerDefineProperty(this, "currentAccount", _descriptor6, this);
      _initializerDefineProperty(this, "currentUser", _descriptor7, this);
      _initializerDefineProperty(this, "socialProfile", _descriptor8, this);
      _initializerDefineProperty(this, "ownerEmail", _descriptor9, this);
      _initializerDefineProperty(this, "ownerName", _descriptor10, this);
      _initializerDefineProperty(this, "inFlight", _descriptor11, this);
      _initializerDefineProperty(this, "isHighlighted", _descriptor12, this);
      _initializerDefineProperty(this, "inputValue", _descriptor13, this);
    }
    get companyName() {
      if (!(0, _utils.isEmpty)(this.socialProfile)) {
        return `${this.socialProfile.displayNickname} -- ${this.socialProfile.platformAbbreviation}`;
      }
      return null;
    }
    get canDestroy() {
      return this.inputValue === this.intl.t('account.profile.leave.type_destroy_word') && !this.inFlight;
    }
    onInsert(element) {
      element.addEventListener('submit', () => false);
    }
    deleteConfirmation() {
      if (!this.canDestroy) {
        this.isHighlighted = true;
        (0, _runloop.later)(() => {
          this.isHighlighted = false;
        }, 3000);
      } else {
        const form = document.getElementById('accountDeleteFeedback');
        const reasons = form.querySelectorAll('input[name="Reason"]');
        let isChecked = false;
        let selectedReason = null;
        const comment = form.querySelector('textarea[name="Message"]')?.value;
        for (const reason of reasons) {
          if (reason.checked) {
            isChecked = true;
            selectedReason = reason.value;
          }
        }
        if (isChecked) {
          _classPrivateMethodGet(this, _trackAccountDeletion, _trackAccountDeletion2).call(this, selectedReason, comment);
          this.leave();
        } else {
          this.alerts.alert(this.intl.t('alerts.account.profile.leave.select_reason'));
        }
      }
    }
    addEventListeners() {
      const deleteForm = document.getElementById('accountDeleteConfirmation');
      deleteForm.addEventListener('submit', () => false);
    }
    leave() {
      this.inFlight = true;
      document.querySelector('#deleteConfirmation').classList.add('o--btn--disabled');
      this.destroyAccountAndLogout();
    }
    async destroyAccountAndLogout() {
      try {
        await this.currentAccount.destroyRecord();
        await this.auth.logout.perform();
        (0, _redirect.default)('https://later.com/?goodbye=true');
      } catch (error) {
        this.errors.handleAdapter(error);
      }
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "currentAccount", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "currentUser", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "socialProfile", [_dec3], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "ownerEmail", [_dec4], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "ownerName", [_dec5], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "inFlight", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "isHighlighted", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "inputValue", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "deleteConfirmation", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "deleteConfirmation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addEventListeners", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addEventListeners"), _class.prototype)), _class));
  function _trackAccountDeletion2(reason, comment) {
    const payload = {
      reason,
      comment
    };
    this.segment.track('deleted-account', payload);
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, LeaveLaterComponent);
});